import { render, staticRenderFns } from "./ReleasedIpsBody.vue?vue&type=template&id=6b2791aa&scoped=true"
import script from "./ReleasedIpsBody.vue?vue&type=script&lang=js"
export * from "./ReleasedIpsBody.vue?vue&type=script&lang=js"
import style0 from "./ReleasedIpsBody.vue?vue&type=style&index=0&id=6b2791aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2791aa",
  null
  
)

export default component.exports